import type { MentionsResponse } from '@atlassian/jira-mentions-indicator';
import type { CardId } from '../../../model/types';

export const MENTIONS_LOAD_SUCCESS = 'state.actions.issue.mentions.MENTIONS_LOAD_SUCCESS' as const;
export const CLEAR_MENTIONS_OPTIMISTIC = 'state.actions.issue.mentions.CLEAR_MENTIONS' as const;

export type MentionsLoadSuccessAction = {
	type: typeof MENTIONS_LOAD_SUCCESS;
	payload: MentionsResponse[];
};

export const mentionsLoadSuccess = (mentions: MentionsResponse[]): MentionsLoadSuccessAction => ({
	type: MENTIONS_LOAD_SUCCESS,
	payload: mentions,
});

export type ClearMentionsOptimisticAction = {
	type: typeof CLEAR_MENTIONS_OPTIMISTIC;
	payload: {
		cardId: CardId;
	};
};

export const clearMentionsOptimisticAction = (cardId: CardId): ClearMentionsOptimisticAction => ({
	type: CLEAR_MENTIONS_OPTIMISTIC,
	payload: {
		cardId,
	},
});
